import CheckLineIcon from '../../../componentsNew/atoms/icons/CheckLineIcon';
import { classNames } from '../../../componentsNew/utils';
import styles from './StepperCircle.module.css';

interface StepperCircleProps {
    checked?: boolean
}

const StepperCircle = ({
    checked = false,
}: StepperCircleProps) => {
    return (
        <div className={styles.container}>
            <div className={classNames(styles.stepperCircle, checked && styles.checked)}>
                <div className={styles.dot}></div>
                <CheckLineIcon className={styles.checkIcon}/>
            </div>
        </div>
    );
}

export default StepperCircle;
